import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator } from "../../../../utils/common";

export function getDistributorCornerNew() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getDistributorCornerNew())
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.GET_DISTRIBUTOR_CORRNER, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}

export function getDistributorCornerFaqs({},formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getDistributorCornerFaqs(formDataValue))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({
            type: ACTION.GET_DISTRIBUTOR_CORRNER_FAQ,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}

export function getDistriutorCornerOnboardDigitally(serverData, typeData) {
  let filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
  } else {
    filterTypeData = typeData;
  }

  return (dispatch) => {
    // dispatch(showMainLoader());
    return request(
      requestConfig.getDistriutorCornerOnboardDigitally(filterTypeData)
    )
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({
            type: ACTION.GET_DISTRIBUTOR_CORRNER_ONBOARD_DIGITALLY,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}

export function getDistriutorCornerOnboardLogin() {
  return (dispatch) => {
    // dispatch(showMainLoader());
    return request(requestConfig.getDistriutorCornerOnboardLogin())
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({
            type: ACTION.GET_DISTRIBUTOR_CORRNER_ONBOARD_LOGIN,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}

export function getDistributorCornerMFD(serverData, filterType) {
  let filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
    if (filterTypeData == "why-become-mfd") {
      filterTypeData = "why-be-a-mfd-distributor";
    }
  } else {
    filterTypeData = filterType;
  }

  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getDistributorCornerMFD(filterTypeData))
      .then((json) => {
        dispatch(hideMainLoader());
        filterTypeData == "why-be-a-mfd-distributor" &&
          json &&
          dispatch({ type: ACTION.DISTRIBUTOR_CORRNER_WHYBE, data: json.data });
        filterTypeData == "get-started" &&
          json &&
          dispatch({
            type: ACTION.DISTRIBUTOR_CORRNER_GETSTARTED,
            data: json.data,
          });
        filterTypeData == "become-an-distributor" &&
          json &&
          dispatch({
            type: ACTION.DISTRIBUTOR_BECOME_DISTRIBUTOR,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributorCorner MFD " + error);
      });
  };
}

export function getDistributorCornerFormsDisclosure(
  serverData,
  formData,
  typeData
) {
  let formDataValue, filterTypeData;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    filterTypeData = urlArray[urlArray.length - 1];
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
    filterTypeData = typeData;
  }

  return (dispatch) => {
    // dispatch(showMainLoader());
    return request(
      requestConfig.getDistributorCornerFormsDisclosure(
        formDataValue,
        filterTypeData
      )
    )
      .then((json) => {
        // dispatch(hideMainLoader());
        json &&
          dispatch({
            type: ACTION.DISTRIBUTOR_CORRNER_FORM_DISCLOSURE,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}

export function getDistributerSEBI(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getDistributerSEBI(formDataValue))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.DISTRIBUTOR_CORRNER_SEBI, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}
export function getHandBook() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getHandBook())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_HANDBOOK, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}
export function getHandBookDetails(serverData,msg) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    msg = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getHandBookDetails(msg))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.GET_HANDBOOK_DETAILS, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with distributor content data: " + error);
      });
  };
}
